import React, { Fragment, PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Segment, Header } from "semantic-ui-react";
import { Formik, Form } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikConfirmedEmailInput from "../forms/formik/FormikConfirmedEmailInput.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

import accountSelectors from "../../state/reducers/account/accountSelectors.js";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

// Designed to be used with the withBasicForm HOC

class ChangeEmailForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    renderMessage: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired,

    emailUpdateAvailability: PropTypes.bool.isRequired
  };

  static defaultProps = {
    copyKey: "account.email"
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      email: "",
      emailConfirmation: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      email: Schemas.emailSchema("Email", messages, true),
      emailConfirmation: Schemas.emailConfirmationSchema(
        "Email confirmation",
        messages,
        true
      )
    });
  };

  // -- RENDER -- //

  render() {
    const {
      data,
      onReset,
      onSubmit,
      onFormikSubmit,
      renderMessage,
      violationErrors,
      emailUpdateAvailability,
      copyKey,
      copy
    } = this.props;

    if (emailUpdateAvailability === true) {
      return (
        <Formik
          initialValues={this.initialValues} // required by semantic-ui react
          validateOnMount={true}
          validationSchema={this.validationSchema()}
          onSubmit={onFormikSubmit}
        >
          {formikProps => {
            return (
              <Segment vertical padded textAlign="left">
                <Form className="ui form">
                  <Header as="h3">{copy(`${copyKey}.title`)}</Header>
                  <p>
                    {copy(`${copyKey}.body`)} <strong>{data.email}</strong>
                  </p>

                  {renderMessage(formikProps)}

                  <FormikConfirmedEmailInput apiErrors={violationErrors} />

                  <FormikActionsPanel
                    reset={true}
                    onReset={onReset}
                    submit={true}
                    useSubmitModal={true}
                    onSubmit={onSubmit}
                    modalCopy={copy(`account.modals`)}
                  />
                </Form>
              </Segment>
            );
          }}
        </Formik>
      );
    }

    return (
      <Segment vertical padded textAlign="left">
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <SegmentMessage
          info={true}
          message={copy(`${copyKey}.email_disabled`)}
        />
        <p>
          {copy(`${copyKey}.body`)} <strong>{data.email}</strong>
        </p>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  emailUpdateAvailability: accountSelectors.selectEmailUpdateAvailability(state)
});

export default connect(mapStateToProps)(ChangeEmailForm);
